/**
 * Вставка HTML с <script> в живой документ.
 * innerHTML/template для кусков из API ненадёжны: парсер часто пустит или ломает тело <script>.
 * DOMParser сохраняет текст скрипта; затем создаём новые script-элементы — браузер их выполняет.
 */
export function injectExecutableHtml(html: string, parent: ParentNode): void {
    const trimmed = html?.trim();
    if (!trimmed) {
        return;
    }

    const inHead = parent instanceof HTMLHeadElement;
    const wrapped = inHead
        ? `<!DOCTYPE html><html><head>${trimmed}</head><body></body></html>`
        : `<!DOCTYPE html><html><head></head><body>${trimmed}</body></html>`;

    const doc = new DOMParser().parseFromString(wrapped, "text/html");

    if (doc.querySelector("parsererror")) {
        return;
    }

    const source = inHead ? doc.head : doc.body;
    const toInject = Array.from(source.childNodes);

    for (const node of toInject) {
        if (node.nodeType === Node.TEXT_NODE) {
            continue;
        }
        if (node.nodeType === Node.COMMENT_NODE) {
            continue;
        }
        if (node.nodeName === "SCRIPT") {
            const old = node as HTMLScriptElement;
            const script = document.createElement("script");
            Array.from(old.attributes).forEach((attr) => {
                script.setAttribute(attr.name, attr.value);
            });
            if (old.src) {
                script.src = old.src;
            } else if (old.textContent !== null && old.textContent !== "") {
                script.textContent = old.textContent;
            }
            parent.appendChild(script);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            parent.appendChild(document.importNode(node as Node, true));
        }
    }
}
